<template>
  <p>
    <span v-if="Number(floatPrice) < 0" style="color: #079f93">{{
      floatPrice
    }}</span>
    <span v-else-if="Number(floatPrice) > 0" style="color: #EA6535">{{
      "+" + floatPrice
    }}</span>
    <span v-else style="color: #ccc">{{ floatPrice }}</span>
  </p>
</template>

<script>
export default {
  props: ["floatPrice"],
};
</script>